export const getDiscount = (compareAtPrice, price) =>
  compareAtPrice && compareAtPrice > price ? (+compareAtPrice - +price).toFixed(2) : null;
